import { Link } from 'react-router-dom'
import type { InhabitSession } from './useInhabitSession'
import Feed from './parts/Feed'
import Curtain from './parts/Curtain'
import Margin from './parts/Margin'
import WillLine from './parts/WillLine'
import styles from './Surface.module.css'

/**
 * The cinema house, for a device with room and a keyboard.
 *
 * The four forms (inhabit-format §2.3): presence = the feed · seam = the
 * curtain · state = the margin · input = the will line and its affordances.
 *
 * Purely what the surface SHOWS. When a phone surface is written it becomes a
 * sibling of this file — and the will line is where it will most want to
 * differ, since the affordances exist precisely so the player need not type.
 */
export default function InhabitDesktop({ session }: { session: InhabitSession }) {
  const s = session

  if (!s.sessionId) {
    return (
      <div className={styles.threshold}>
        <div className={styles.thresholdInner}>
          <h1 className={styles.title}>{s.scenario?.title ?? s.packId}</h1>
          {s.scenario && <p className={styles.opening}>{s.scenario.blurb}</p>}
          <button className={styles.enter} onClick={s.begin} disabled={s.starting}>
            {s.starting ? 'CROSSING…' : 'ENTER'}
          </button>
          {s.error && <p className={styles.error}>{s.error}</p>}
          <div>
            <Link to="/" className={styles.back}>
              ‹ BACK
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.surface}>
      <Margin standing={s.standing} doing={s.doing} />

      <Feed
        lines={s.lines}
        thinking={s.thinking}
        endedReason={
          s.terminated ? (s.terminationReason ?? 'the visit ends here') : null
        }
      />

      {!s.terminated && (
        <WillLine affordances={s.affordances} onSubmit={s.submit} />
      )}

      <Curtain card={s.card} onDone={s.dismissCard} />
    </div>
  )
}
